import axios from 'axios';

export default {
  // TODO: 7635 хз зачем так делать надо было, дичь - если будет не актуально, то удалить
  setOptionsList({ commit, state, dispatch, rootState }, params) {
    // let models = rootState.models.models;
    // let system = rootState.models.system;
    // let model = rootState.models.model;
    // let subModel = rootState.models.subModel;
    // if (models !== null && model !== null) {
    //   if (models[system]?.models[model]?.sub_models.length > 0) {
    //     dispatch('loadOptions', {
    //       'id': models[system].models[model].sub_models[subModel].id,
    //       'basket': params && params.basket ? params && params.basket : null,
    //     })
    //   } else if(models[system]?.models[model]?.id) {
    //     dispatch('loadOptions', {
    //       'id': models[system].models[model].id,
    //       'basket': params && params.basket ? params && params.basket : null,
    //     })
    //   }
    // }
  },

  // Важно, запрашивать после выбора модели, ибо у нас могут быть разные размеры, которые вытягиваются из опций
  // Размер || Тип окна
  loadOptions({ commit, dispatch }, { id, basket }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_API_URL}/api/models/${id}/options`)
        .then(
          res => {
            resolve(res.data);
            if (basket) {
              commit('updateOptionsListOriginal', res.data);
              dispatch('setOptionsListEditOrder', basket);
            } else {
              commit('updateOptionsList', res.data);
            }
          },
          error => {
            reject(error);
          },
        )
        .finally(() => {
          commit('updateOptionsCount');
        });
    });
  },

  setOptionsListEditOrder({ commit, state }, params) {
    let result = state.optionsListOriginal;

    result.forEach(el => {
      params.find(item => {
        if (item.name === el.name && item.option_value !== el.option_default) {
          el.option_default = item.option_value;
        }
      });
    });

    commit('updateOptionsListData', result);
    setTimeout(() => {
      commit('updateOptionsCount');
    }, 500);
  },

  optionsClear({ commit, dispatch, state }) {
    commit('updateOptionsComment', '');
    commit('updateOptionsList', state.optionsListOriginal);
  },
};
